// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1QnRw","disabled":"FileBtn_disabled__2zdGa","warn":"FileBtn_warn__2Y8QR","fade":"FileBtn_fade__2onGg"};